"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spiral = void 0;
const math_1 = require("../../math");
const ShapeLoop_1 = require("../ShapeLoop");
/**
 * Spiral shape
 *
 * @category Shapes.ShapeLoop
 * @class Spiral
 * @extends {ShapeLoop}
 */
class Spiral extends ShapeLoop_1.ShapeLoop {
    /**
     * Creates an instance of Spiral.
     *
     * @param {SpiralSettings} [settings={}]
     * @memberof Spiral
     */
    constructor(settings = {}) {
        var _a, _b, _c;
        settings.type = 'Spiral';
        settings.bClosed = false;
        settings.loopDependencies = (settings.loopDependencies || []).concat(['twists', 'twistsStart', 'spiral']);
        super(settings, true);
        this.props.spiral = (_a = settings.spiral) !== null && _a !== void 0 ? _a : Spiral.types.ARCHIMEDE;
        this.props.twists = (_b = settings.twists) !== null && _b !== void 0 ? _b : 2;
        this.props.twistsStart = (_c = settings.twistsStart) !== null && _c !== void 0 ? _c : 0;
        this.loop = {
            start: (propArguments) => math_1.PI2 * this.getProp('twistsStart', propArguments),
            end: (propArguments) => math_1.PI2 *
                (this.getProp('twistsStart', propArguments) + this.getProp('twists', propArguments)),
            inc: (propArguments) => {
                const twists = this.getProp('twists', propArguments);
                const rep = math_1.PI2 * twists;
                const sideLength = this.getRepetitionSideLength(propArguments);
                const radius = 4 + Math.sqrt(sideLength[0] * sideLength[1]);
                return rep / (radius * twists);
            },
            vertex: (shapeLoopRepetition) => {
                const r = this.r(shapeLoopRepetition.current);
                return [r * Math.cos(shapeLoopRepetition.current), r * Math.sin(shapeLoopRepetition.current)];
            },
        };
        this.bStaticLoop = this.isStaticLoop();
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
    generateLoopBuffer(propArguments) {
        this.spiral = this.getProp('spiral', propArguments);
        this.r = Spiral.getRFromTSpiralType(this.spiral);
        return super.generateLoopBuffer(propArguments);
    }
    /**
     * Point position and scale factor for spiral types
     *
     * @static
     * @param {TSpiralType} spiral
     * @returns {number}
     * @memberof Spiral
     */
    static getRFromTSpiralType(spiral) {
        switch (spiral) {
            case Spiral.types.ARCHIMEDE:
                return angle => angle / 10;
            case Spiral.types.HYPERBOLIC:
                return angle => (1 / angle) * 3;
            case Spiral.types.FERMAT:
                return angle => angle ** 0.5 / 3;
            case Spiral.types.LITUUS:
                return angle => angle ** -0.5;
            case Spiral.types.LOGARITHMIC:
                return angle => Math.E ** (angle * 0.2) / 10;
        }
        return angle => angle;
    }
}
exports.Spiral = Spiral;
/**
 * Spural types
 *
 * @static
 * @type {{ [name in TSpiralType]: TSpiralType }}
 * @memberof Spiral
 */
Spiral.types = {
    ARCHIMEDE: 'ARCHIMEDE',
    HYPERBOLIC: 'HYPERBOLIC',
    FERMAT: 'FERMAT',
    LITUUS: 'LITUUS',
    LOGARITHMIC: 'LOGARITHMIC',
};
//# sourceMappingURL=Spiral.js.map